// ============================================================================
// PORTUGUESE TRANSLATIONS - CHAPTER 3: JESUS CRISTO
// ============================================================================
// Níveis 27-39 (13 níveis, 39 perguntas)

export const chapter3Translations = {
  name: 'Jesus Cristo',
  description: 'O Verbo se fez carne... Conhecer Cristo é a vida eterna',
  
  spiritualWisdom: {
    principle: 'Conhecer Jesus Cristo é a vida eterna',
    scripture: 'E a vida eterna é esta: que te conheçam a ti, o único Deus verdadeiro, e a Jesus Cristo, a quem enviaste (João 17:3)',
    application: 'Cada aspecto da vida de Jesus revela Deus e nutre nossa alma para a eternidade'
  },
  
  levels: {
    27: {
      name: 'A Anunciação',
      challenge: 'O anjo Gabriel foi enviado por Deus a uma cidade da Galileia...',
      easy: {
        question: 'Qual anjo anunciou a Maria que ela daria à luz Jesus?',
        options: ['Miguel', 'Gabriel', 'Rafael', 'Uriel'],
        hint: 'O anjo mensageiro de Deus',
        funFact: '👼 Gabriel significa Força de Deus - o anjo dos grandes anúncios!'
      },
      medium: {
        question: 'Qual foi a primeira reação de Maria a este anúncio?',
        options: [
          'Alegria imediata',
          'Incredulidade total',
          'Perturbação e a pergunta Como se fará isso?',
          'Medo'
        ],
        hint: 'Uma pergunta prática e legítima',
        funFact: '🤔 Maria faz uma pergunta lógica, mas mantém um coração aberto a Deus!'
      },
      hard: {
        question: 'O que nos ensina a submissão de Maria à vontade divina?',
        options: [
          'A passividade diante das provações',
          'A fé que confia mesmo sem entender tudo',
          'A obediência cega',
          'A resignação'
        ],
        hint: 'Trata-se de confiar em Deus mesmo no desconhecido',
        funFact: '🙏 Faça-se em mim segundo a tua palavra - modelo de fé confiante!'
      }
    },
    
    28: {
      name: 'A Natividade',
      challenge: 'Deu à luz seu filho primogênito, envolveu-o em faixas e o deitou numa manjedoura...',
      easy: {
        question: 'Em que cidade Jesus nasceu?',
        options: ['Nazaré', 'Jerusalém', 'Belém', 'Cafarnaum'],
        hint: 'A cidade de Davi',
        funFact: '🏘️ Belém significa Casa do Pão - Jesus, pão da vida!'
      },
      medium: {
        question: 'Quem recebeu primeiro o anúncio do nascimento?',
        options: [
          'Os magos',
          'Os pastores nos campos',
          'Os sacerdotes do Templo',
          'A família de Maria'
        ],
        hint: 'Pessoas simples que guardavam seus rebanhos',
        funFact: '🐑 Deus anuncia primeiro aos humildes pastores - o Evangelho para todos!'
      },
      hard: {
        question: 'O que simboliza Jesus nascido numa manjedoura?',
        options: [
          'A pobreza de seus pais',
          'A humildade de Deus que se abaixa até nós',
          'A falta de lugar',
          'A simplicidade rural'
        ],
        hint: 'Trata-se da encarnação divina na humildade',
        funFact: '👶 O Criador do universo nasce num estábulo - amor infinito!'
      }
    },

    29: {
      name: 'Os Magos do Oriente',
      challenge: 'Magos do Oriente chegaram a Jerusalém e perguntaram...',
      easy: {
        question: 'O que guiou os magos até Jesus?',
        options: ['Um anjo', 'Uma estrela', 'Uma visão', 'Um mapa'],
        hint: 'Um astro no céu',
        funFact: '⭐ A estrela representa que Jesus é a luz das nações!'
      },
      medium: {
        question: 'Que presentes ofereceram os magos?',
        options: [
          'Comida',
          'Ouro, incenso e mirra',
          'Roupas preciosas',
          'Brinquedos'
        ],
        hint: 'Três presentes simbólicos e preciosos',
        funFact: '🎁 Ouro (realeza), incenso (divindade), mirra (sacrifício) - toda a missão de Jesus!'
      },
      hard: {
        question: 'O que representam estes magos pagãos no plano de Deus?',
        options: [
          'A superioridade de outras religiões',
          'A universalidade da salvação oferecida a todos os povos',
          'A riqueza material',
          'A ciência antiga'
        ],
        hint: 'Trata-se da abertura da salvação a todas as nações',
        funFact: '🌍 Os magos prefiguram o Evangelho que alcançará o mundo inteiro!'
      }
    },

    30: {
      name: 'O Batismo de Jesus',
      challenge: 'Assim que foi batizado, Jesus saiu da água...',
      easy: {
        question: 'Quem batizou Jesus?',
        options: ['Pedro', 'João Batista', 'André', 'Tiago'],
        hint: 'O precursor de Jesus',
        funFact: '🌊 João Batista considerava-se indigno de desatar as sandálias de Jesus!'
      },
      medium: {
        question: 'O que desceu sobre Jesus no seu batismo?',
        options: [
          'Uma luz',
          'Uma pomba (o Espírito Santo)',
          'Um anjo',
          'Apenas uma voz'
        ],
        hint: 'A ave símbolo da paz',
        funFact: '🕊️ A pomba revela a unção divina para iniciar o ministério!'
      },
      hard: {
        question: 'Por que Jesus, sem pecado, foi batizado?',
        options: [
          'Para dar o exemplo',
          'Para cumprir toda a justiça e identificar-se conosco',
          'Por obrigação religiosa',
          'Para receber perdão'
        ],
        hint: 'Trata-se de solidariedade com a humanidade pecadora',
        funFact: '❤️ Jesus identifica-se totalmente conosco para nos salvar melhor!'
      }
    },

    31: {
      name: 'A Tentação no Deserto',
      challenge: 'Jesus foi conduzido pelo Espírito ao deserto para ser tentado pelo diabo...',
      easy: {
        question: 'Quanto tempo Jesus jejuou no deserto?',
        options: ['30 dias', '40 dias', '50 dias', '60 dias'],
        hint: 'O número bíblico da provação',
        funFact: '🏜️ Como Moisés e Elias, 40 dias de preparação espiritual intensa!'
      },
      medium: {
        question: 'Como Jesus rejeitou cada tentação?',
        options: [
          'Com sua própria força',
          'Citando as Escrituras',
          'Ignorando Satanás',
          'Apenas orando'
        ],
        hint: 'A arma espiritual por excelência',
        funFact: '📖 Está escrito... - a Palavra de Deus, espada do Espírito!'
      },
      hard: {
        question: 'O que nos ensina a tentação de Jesus sobre nossos combates?',
        options: [
          'As tentações são pecado',
          'A tentação pode ser vencida pela Palavra e pela fé',
          'É preciso fugir de todo deserto',
          'Só Jesus pode resistir'
        ],
        hint: 'Trata-se de nossa estratégia contra as tentações',
        funFact: '⚔️ Jesus nos mostra como vencer: Palavra de Deus + fé ativa!'
      }
    },

    32: {
      name: 'Os Primeiros Discípulos',
      challenge: 'Jesus lhes disse: Vinde após mim, e eu vos farei pescadores de homens...',
      easy: {
        question: 'Qual era a profissão de Pedro e André?',
        options: ['Pastores', 'Pescadores', 'Carpinteiros', 'Cobradores de impostos'],
        hint: 'Uma profissão do lago da Galileia',
        funFact: '🎣 Jesus transforma pescadores de peixes em pescadores de almas!'
      },
      medium: {
        question: 'Como reagiram os primeiros discípulos ao chamado?',
        options: [
          'Hesitaram muito tempo',
          'Pediram provas',
          'Deixaram tudo e o seguiram imediatamente',
          'Negociaram'
        ],
        hint: 'Uma resposta imediata e total',
        funFact: '🚶 A autoridade de Jesus era tão evidente que obedeceram instantaneamente!'
      },
      hard: {
        question: 'O que significa seguir Jesus em nossa época?',
        options: [
          'Abandonar o trabalho',
          'Viver segundo seus ensinamentos e sua vontade',
          'Juntar-se a uma comunidade isolada',
          'Fazer proselitismo apenas'
        ],
        hint: 'Trata-se de uma transformação de vida e de prioridades',
        funFact: '✨ Seguir Jesus transforma nossos corações, escolhas, destino!'
      }
    },

    33: {
      name: 'O Sermão do Monte',
      challenge: 'Bem-aventurados os pobres de espírito, porque deles é o reino dos céus...',
      easy: {
        question: 'Qual é a primeira bem-aventurança do Sermão do Monte?',
        options: [
          'Bem-aventurados os puros de coração',
          'Bem-aventurados os pobres de espírito',
          'Bem-aventurados os mansos',
          'Bem-aventurados os pacificadores'
        ],
        hint: 'Refere-se à humildade espiritual',
        funFact: '😊 Os pobres de espírito conhecem sua necessidade de Deus - porta do Reino!'
      },
      medium: {
        question: 'O que Jesus disse sobre os pacificadores?',
        options: [
          'Serão afortunados',
          'Serão chamados filhos de Deus',
          'Serão amados',
          'Serão poderosos'
        ],
        hint: 'Uma identidade divina especial',
        funFact: '👑 Os pacificadores são semelhantes a Deus - testemunho vivo de Sua natureza!'
      },
      hard: {
        question: 'Como as bem-aventuranças invertem os valores do mundo?',
        options: [
          'Condenando a riqueza',
          'Isolando os crentes',
          'Declarando abençoados aqueles que o mundo despreza',
          'Abolindo as leis'
        ],
        hint: 'Trata-se de valores divinos contrários aos mundanos',
        funFact: '🔄 As bem-aventuranças transformam nossa visão de felicidade e sucesso!'
      }
    },

    34: {
      name: 'As Parábolas do Reino',
      challenge: 'Ele lhes ensinou muitas coisas por parábolas...',
      easy: {
        question: 'Na parábola do semeador, o que representa a semente?',
        options: [
          'Dinheiro',
          'A Palavra de Deus',
          'Boas obras',
          'Amor'
        ],
        hint: 'O que Jesus proclama e ensina',
        funFact: '🌱 A Palavra de Deus germina e cresce em nossos corações!'
      },
      medium: {
        question: 'Na parábola do grão de mostarda, o que simboliza esta semente minúscula?',
        options: [
          'Fraqueza humana',
          'O Reino que começa pequeno mas se torna grande',
          'Importância dos detalhes',
          'A natureza'
        ],
        hint: 'Algo que cresce de forma impressionante',
        funFact: '🌳 Da menor semente nasce uma grande árvore - poder do Reino!'
      },
      hard: {
        question: 'Por que Jesus ensinava em parábolas?',
        options: [
          'Para complicar Sua mensagem',
          'Para revelar verdades espirituais através de imagens familiares',
          'Por falta de tempo',
          'Para testar inteligência'
        ],
        hint: 'Trata-se de tornar acessíveis os mistérios do Reino',
        funFact: '💡 As parábolas revelam aos corações abertos e escondem dos fechados!'
      }
    },

    35: {
      name: 'Os Milagres de Jesus',
      challenge: 'Ele acalmou a tempestade e disse ao mar: Aquieta-te! Acalma-te!...',
      easy: {
        question: 'Com quantos pães Jesus alimentou 5000 homens?',
        options: ['3 pães', '5 pães', '7 pães', '12 pães'],
        hint: 'O mesmo número que os peixes',
        funFact: '🍞 5 pães e 2 peixes se tornam um banquete - generosidade divina!'
      },
      medium: {
        question: 'O que os discípulos disseram quando Jesus acalmou a tempestade?',
        options: [
          'Ele é um mágico',
          'Quem é este que até o vento e o mar lhe obedecem?',
          'É normal',
          'Devemos sair daqui'
        ],
        hint: 'Uma pergunta sobre a identidade de Jesus',
        funFact: '⛈️ Até os elementos reconhecem seu Criador e Senhor!'
      },
      hard: {
        question: 'Qual é o propósito principal dos milagres de Jesus?',
        options: [
          'Impressionar as multidões',
          'Revelar Sua divindade e manifestar o amor de Deus',
          'Ganhar influência',
          'Ajudar apenas materialmente'
        ],
        hint: 'Trata-se de revelação divina e compaixão',
        funFact: '❤️ Cada milagre revela o coração de Deus: amor, compaixão, poder!'
      }
    },

    36: {
      name: 'A Transfiguração',
      challenge: 'E foi transfigurado diante deles; seu rosto resplandeceu como o sol...',
      easy: {
        question: 'Quais discípulos viram Jesus transfigurado?',
        options: [
          'Todos os doze',
          'Pedro, Tiago e João',
          'Apenas Pedro e João',
          'As mulheres que o seguiam'
        ],
        hint: 'O círculo íntimo dos três',
        funFact: '⛰️ Pedro, Tiago e João: testemunhas privilegiadas da glória divina!'
      },
      medium: {
        question: 'Quais figuras do Antigo Testamento apareceram?',
        options: [
          'Abraão e Isaque',
          'Davi e Salomão',
          'Moisés e Elias',
          'Adão e Noé'
        ],
        hint: 'O representante da Lei e dos Profetas',
        funFact: '📜 Moisés (Lei) e Elias (Profetas) testemunham de Jesus!'
      },
      hard: {
        question: 'O que esta transfiguração revela sobre a natureza de Jesus?',
        options: [
          'Ele é um grande profeta',
          'Sua divindade oculta se revela temporariamente',
          'Ele controla a luz',
          'Ele pode mudar de aparência'
        ],
        hint: 'Trata-se da revelação de Sua natureza divina',
        funFact: '✨ A glória divina de Jesus resplandece - antecipação de Sua ressurreição!'
      }
    },

    37: {
      name: 'A Entrada Triunfal',
      challenge: 'Hosana ao Filho de Davi! Bendito o que vem em nome do Senhor!...',
      easy: {
        question: 'Em qual animal Jesus entrou em Jerusalém?',
        options: ['Cavalo', 'Jumento', 'Camelo', 'A pé'],
        hint: 'Animal símbolo de humildade e paz',
        funFact: '🐴 O jumento simboliza o Rei humilde que vem em paz, não em guerra!'
      },
      medium: {
        question: 'O que a multidão gritou ao receber Jesus?',
        options: [
          'Viva o Rei!',
          'Hosana! Bendito o que vem em nome do Senhor!',
          'Glória a Deus!',
          'Liberdade!'
        ],
        hint: 'Um grito de alegria e bênção',
        funFact: '🌿 "Hosana" significa "salva agora" - invocação de salvação divina!'
      },
      hard: {
        question: 'Por que esta entrada é "triunfal" mas trágica?',
        options: [
          'Havia poucas pessoas',
          'A multidão que o aclama o rejeitará em 5 dias',
          'As autoridades estavam ausentes',
          'Estava chovendo'
        ],
        hint: 'Trata-se da inconstância do coração humano',
        funFact: '💔 A mesma multidão gritará "Crucifica-o!" poucos dias depois!'
      }
    },

    38: {
      name: 'A Última Ceia',
      challenge: 'Tomai e comei, isto é o meu corpo que é dado por vós...',
      easy: {
        question: 'O que Jesus fez com os pés de seus discípulos?',
        options: [
          'Abençoou-os',
          'Lavou-os',
          'Perfumou-os',
          'Beijou-os'
        ],
        hint: 'Um gesto de humildade e serviço',
        funFact: '🦶 O Mestre se torna servo - revolução de amor e humildade!'
      },
      medium: {
        question: 'O que Jesus instituiu nesta ceia?',
        options: [
          'O batismo',
          'A Eucaristia (Santa Ceia)',
          'O Pai Nosso',
          'O jejum'
        ],
        hint: 'Um sacramento com pão e vinho',
        funFact: '🍞🍷 Pão e vinho se tornam símbolos eternos de sacrifício e amor!'
      },
      hard: {
        question: 'O que significa "Fazei isto em memória de mim"?',
        options: [
          'Repitam esta ceia',
          'Celebrem minha morte e ressurreição até que eu volte',
          'Lembrem-se de minhas palavras',
          'Amem uns aos outros'
        ],
        hint: 'Trata-se de uma comemoração viva e profética',
        funFact: '⏳ Cada Eucaristia anuncia a morte do Senhor até que Ele venha!'
      }
    },

    39: {
      name: 'Getsêmani',
      challenge: 'Pai meu, se possível, passa de mim este cálice...',
      easy: {
        question: 'Onde Jesus orou antes de sua prisão?',
        options: [
          'No Templo',
          'No jardim do Getsêmani',
          'No Monte das Oliveiras',
          'Na casa de amigos'
        ],
        hint: 'Um jardim de oliveiras',
        funFact: '🫒 Getsêmani significa "prensa de azeite" - lugar de pressão intensa!'
      },
      medium: {
        question: 'O que os discípulos fizeram enquanto Jesus orava?',
        options: [
          'Oraram com ele',
          'Adormeceram',
          'Montaram guarda',
          'Foram embora'
        ],
        hint: 'Não conseguiram vigiar nem uma hora',
        funFact: '😴 O espírito está pronto mas a carne é fraca - fragilidade humana!'
      },
      hard: {
        question: 'O que a agonia de Jesus revela sobre sua natureza?',
        options: [
          'Ele era apenas homem',
          'Ele era plenamente homem e plenamente Deus',
          'Ele duvidava de sua missão',
          'Ele era fraco'
        ],
        hint: 'Trata-se do mistério da Encarnação',
        funFact: '✝️ Jesus carrega plenamente a angústia humana permanecendo fiel a Deus!'
      }
    }
  }
};

export default chapter3Translations;
